import React, { useRef } from "react";
import ReactImageGallery from "react-image-gallery";

function PhotoSliderFullscreen({
  base_url,
  photos,
  showThumbnails = false,
  showFullscreenButton = false,
  startIndex = 0,
  needPrepare = true,
  noAva = "/noava.png",
}) {
  const galleryRef = useRef(null);
  const images = needPrepare ? [] : photos;

  if (needPrepare) {
    if (photos?.length > 0) {
      photos.forEach((photo_item) => {
        images.push({
          original: `${base_url}/${photo_item}.jpg`,
          thumbnail: `${base_url}/${photo_item}.jpg`,
        });
      });
    } else {
      images.push({ original: noAva, thumbnail: noAva });
    }
  }

  const openFullscreen = (e) => {
    if (galleryRef.current) {
      galleryRef.current.fullScreen();
    }
  };

  const sliderSettings = {
    infinite: false,
    itemsToShow: 3,
    showThumbnails,
    thumbnailPosition: "bottom",
    autoPlay: false,
    showFullscreenButton: true,
    showPlayButton: false,
    disableKeyDown: true,
    lazyLoad: true,
    startIndex,
  };

  return (
    <ReactImageGallery
      ref={galleryRef}
      items={images}
      {...sliderSettings}
      onClick={openFullscreen}
    />
  );
}

export default PhotoSliderFullscreen;
